import Vue from 'vue'
import VueRouter from 'vue-router'
import {app} from '../../utils/app'
Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'ShopData',
		component:() => import('../views/ShopData.vue')
	},
	{
		path: '/goods',
		name: 'goods',
		component: () => import('../views/Goods.vue')
	},
	{
		path:'/show',
		name:'show',
		component: ()=>import('../views/Show.vue')
	},
	{
		path:'/join',
		name:'join',
		component: ()=>import('../views/Join.vue')
	},
	{
		path:'/login',
		name:'login',
		component: ()=>import('../views/Login.vue')
	},
	{
		path:'/regist',
		name:'regist',
		component: ()=>import('../views/Regist.vue')
	},
	{
		path:'/ShopLogin',
		name:'ShopLogin',
		component: ()=>import('../views/ShopLogin.vue')
	},
	{
		path:'/ShopRegist',
		name:'ShopRegist',
		component: ()=>import('../views/ShopRegist.vue')
	},{
		path: '/ShopData',
		name: 'ShopData',
		component:() => import('../views/ShopData.vue')
	},{
		path: '/ShopOrderList',
		name: 'ShopOrderList',
		component:() => import('../views/ShopOrderList.vue')
	},{
		path: '/ShopSet',
		name: 'ShopSet',
		component:() => import('../views/ShopSet.vue')
	},{
		path: '/ShopFriends',
		name: 'ShopFriends',
		component:() => import('../views/ShopFriends.vue')
	},{
		path: '/ShopFinance',
		name: 'ShopFinance',
		component:() => import('../views/ShopFinance.vue')
	},{
		path: '/ShopFinanceDaly',
		name: 'ShopFinanceDaly',
		component:() => import('../views/ShopFinanceDaly.vue')
	},{
		path: '/ShopJoin',
		name: 'ShopJoin',
		component:() => import('../views/ShopJoin.vue')
	},{
		path: '/ShopResetPassword',
		name: 'ShopResetPassword',
		component:() => import('../views/ShopResetPassword.vue')
	},{
		path: '/ShopFriendEarn',
		name: 'ShopFriendEarn',
		component:() => import('../views/ShopFriendEarn.vue')
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

let hasUserToken = app.getUserToken()
let hasShopToken = app.getShopToken()
router.beforeEach((to, from, next) => {
	if(!hasUserToken){
		if(to.name == 'ShopData' || to.name == 'ShopRegist') next({ name: 'ShopJoin' })
		else next()
	}else next()
})
router.beforeEach((to, from, next) => {
	if(to.name == 'ShopData'&&!hasUserToken) next({ name: 'ShopLogin' })
	else next()
	next()
})
export default router
